import { SERVICE_URL } from './ServiceURL'

class ScheduleService {

  constructor(resource) {
    this.store = resource.$store;
    this.http = resource.$http;

    this.baseURL = `${SERVICE_URL}v1/schedule`;
  }

  save(schedule) {
    return new Promise((resolve, reject) => {
      this.http.post(this.baseURL, schedule, {
          headers: {
            'x-access-token': this.store.state.user.token || ''
          }
        })
        .then(response => response.json())
        .then(result => {
          resolve()
        })
        .catch(err => {
          console.log("reject")
          reject(err.message || err);
        });
    });
  }

  get() {
    return new Promise((resolve, reject) => {
      this.http.get(this.baseURL, {
          headers: {
            'x-access-token': this.store.state.user.token || ''
          }
        })
        .then(response => response.json())
        .then(result => resolve(result))
        .catch(err => {
          reject(err.message || err);
        });
    })
  }

  update(schedule) {
    return this.http.put(`${this.baseURL}/${schedule.id}`, schedule, {
      headers: {
        'x-access-token': this.store.state.user.token || ''
      }
    }).then(response => response.json())
  }
}
export default ScheduleService;


// WEBPACK FOOTER //
// ./src/service/ScheduleService.js